import { toRGBA } from "./utils";

const felix = [38, 43, 43];
const f = (opacity: number = 1) =>
  toRGBA(felix[0], felix[1], felix[2], opacity);

export default f;
